export const EXCLUDED_PATHNAMES = [
  '/careers',
  '/resources/voiding-your-tire-warranty'
]
